import React, { useState, useEffect, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './FirstScreen.module.css';
import slide1 from "../images/תמונות מתחלפות1.webp"
import slide2 from "../images/תמונות מתחלפות 2.webp"
import slide3 from "../images/תמונות מתחלפות 3.webp"
import slide4 from "../images/תמונות מתחלפות 4.webp"
import slide5 from "../images/תמונות מתחלפות 5.webp"
import slide6 from "../images/תמונות מתחלפות 6.webp"
import slide7 from "../images/תמונות מתחלפות 7.webp"
import slide8 from "../images/תמונות מתחלפות 8.webp"
import desktopSlide1 from "../images/טלי אטיה תמונת פתיחה 1.webp"

import desktopSlide3 from "../images/טלי אטיה תמונת פתיחה 3.webp"
import desktopSlide5 from "../images/טלי אטיה תמונת פתיחה 5.webp"
import desktopSlide6 from "../images/טלי אטיה מתחלפות מחשבים 1.webp"
import desktopSlide7 from "../images/טלי אטיה מתחלפות מחשבים 2.webp"
import PrivacyPolicy from '../components/privacy/Privacy';
import LoadingEffect from '../components/loader/Loader';

gsap.registerPlugin(ScrollTrigger);

const HeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [progress, setProgress] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    reason: ''
  });
  
  const [errors, setErrors] = useState({
    fullName: '',
    phone: '',
    reason: ''
  });

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [agreed, setAgreed] = useState(false);
  
  const heroRef = useRef(null);
  const imageRef = useRef(null);
  const overlayRef = useRef(null);
  const signatureRef = useRef(null);

  const serverUrl = "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const reciver = "tali.atia.interior@gmail.com";

  const mobileProjects = [
    {
      image: slide1,
      title: 'עיצוב חדר שינה',
      subtitle: 'סגנון מודרני'
    },
    {
      image: slide2,
      title: 'עיצוב טבעי',
      subtitle: 'חלל מואר'
    },
    {
      image: slide3,
      title: 'פינת אוכל',
      subtitle: 'סגנון בוהו'
    },
    {
      image: slide4,
      title: 'חדר שינה',
      subtitle: 'עיצוב בוהו שיק'
    },
    {
      image: slide5,
      title: 'סלון מודרני',
      subtitle: 'קווים נקיים'
    },
    {
      image: slide6,
      title: 'חדר שינה',
      subtitle: 'עיצוב סקנדינבי'
    },
    {
      image: slide7,
      title: 'פינת אוכל',
      subtitle: 'מינימליזם מודרני'
    },
    {
      image: slide8,
      title: 'סלון',
      subtitle: 'חמימות ביתית'
    }
  ];

  const desktopProjects = [
    {
      image: desktopSlide1,
      title: 'עיצוב פנים',
      subtitle: 'סגנון מודרני'
    },
{
      image: desktopSlide3,
      title: 'סלון מעוצב',
      subtitle: 'קווים נקיים'
    },
{
      image: desktopSlide5,
      title: 'פינת אוכל',
      subtitle: 'עיצוב ייחודי'
    },
    {
      image: desktopSlide6,
      title: 'עיצוב פנים',
      subtitle: 'סגנון מעוצב'
    },
    {
      image: desktopSlide7,
      title: 'חלל מגורים',
      subtitle: 'עיצוב מודרני'
    }
  ];

  const projects = isDesktop ? desktopProjects : mobileProjects;

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth > 768;
      setIsDesktop(prev => {
        if (prev !== desktop) {
          setCurrentIndex(0);
          setProgress(0);
        }
        return desktop;
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const preloadImages = async () => {
      const imagePromises = projects.map((project) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = project.image;
          img.onload = resolve;
          img.onerror = reject;
        });
      });

      try {
        await Promise.all(imagePromises);
        setImagesLoaded(true);
      } catch (error) {
        console.error('Error loading images:', error);
        setImagesLoaded(true);
      }
    };

    preloadImages();
  }, [projects]);


  useEffect(() => {
    if (!imagesLoaded) return;

    const tl = gsap.timeline({ delay: 0.3 });

    tl.from(imageRef.current, {
      scale: 1.2,
      opacity: 0,
      duration: 2,
      ease: 'power3.out'
    });

    // אנימציה לסקשן החתימה
    if (signatureRef.current) {
      gsap.from(signatureRef.current.querySelectorAll('.animate-in'), {
        y: 30,
        opacity: 0,
        duration: 1.2,
        stagger: 0.2,
        ease: 'power3.out',
        delay: 0.8
      });
    }

    ScrollTrigger.create({
      trigger: heroRef.current,
      start: 'top top',
      end: 'bottom top',
      scrub: 1,
      onUpdate: (self) => {
        const progress = self.progress;
        gsap.to(imageRef.current, {
          scale: 1 + progress * 0.3,
          y: progress * 200,
          ease: 'none'
        });
        gsap.to(overlayRef.current, {
          opacity: 0.3 + progress * 0.4,
          ease: 'none'
        });
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [imagesLoaded]);

  useEffect(() => {
    if (!isAutoPlay || !imagesLoaded) return;

    const duration = 7000;
    const interval = 50;
    let elapsed = 0;

    const timer = setInterval(() => {
      elapsed += interval;
      setProgress((elapsed / duration) * 100);

      if (elapsed >= duration) {
        handleNext();
        elapsed = 0;
        setProgress(0);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [currentIndex, isAutoPlay, imagesLoaded]);

  const animateTransition = (direction) => {
    const tl = gsap.timeline();

    tl.to(imageRef.current, {
      scale: 1.1,
      opacity: 0,
      filter: 'blur(20px)',
      duration: 0.8,
      ease: 'power2.inOut'
    });

    tl.to(imageRef.current, {
      scale: 1,
      opacity: 1,
      filter: 'blur(0px)',
      duration: 1,
      ease: 'power2.out'
    });
  };

  const handleNext = () => {
    animateTransition('next');
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % projects.length);
    }, 600);
  };

  const handlePrev = () => {
    animateTransition('prev');
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + projects.length) % projects.length);
    }, 600);
  };

  const handleDotClick = (index) => {
    if (index === currentIndex) return;
    animateTransition(index > currentIndex ? 'next' : 'prev');
    setTimeout(() => {
      setCurrentIndex(index);
      setProgress(0);
    }, 600);
  };

  const handleMouseEnter = () => {
    setIsAutoPlay(false);
  };

  const handleMouseLeave = () => {
    setIsAutoPlay(true);
    setProgress(0);
  };

  const scrollToProjects = () => {
    const projectsSection = document.getElementById('פרוייקטים');
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactClick = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
    setFormData({
      fullName: '',
      phone: '',
      reason: ''
    });
    setErrors({
      fullName: '',
      phone: '',
      reason: ''
    });
    setIsSubmitting(false);
    setSubmitted(false);
    setAgreed(false);
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const validateForm = () => {
    if (!agreed) {
      alert("עליך לאשר את תנאי השימוש ומדיניות הפרטיות");
      return false;
    }

    let valid = true;
    const newErrors = { fullName: '', phone: '', reason: '' };

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'נא להזין שם מלא';
      alert('נא להזין שם מלא');
      valid = false;
    } else if (formData.fullName.trim().length < 2) {
      newErrors.fullName = 'שם חייב להכיל לפחות 2 תווים';
      alert('שם חייב להכיל לפחות 2 תווים');
      valid = false;
    }

    const phoneRegex = /^0(5\d|[23489])\d{7}$/;
    if (!formData.phone.trim()) {
      newErrors.phone = 'נא להזין מספר טלפון';
      alert('נא להזין מספר טלפון');
      valid = false;
    } else if (!phoneRegex.test(formData.phone.trim())) {
      newErrors.phone = 'נא להזין מספר טלפון תקין';
      alert('נא להזין מספר טלפון תקין');
      valid = false;
    }

    if (!formData.reason.trim()) {
      newErrors.reason = 'נא לבחור סיבת פנייה';
      alert('נא לבחור סיבת פנייה');
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    const serverData = {
      name: formData.fullName,
      phone: formData.phone,
      email: "",
      reason: formData.reason,
      reciver: reciver
    };

    try {
      const serverResponse = await fetch(serverUrl, {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(serverData)
      });

      if (serverResponse.ok) {
        setIsSubmitting(false);
        setSubmitted(true);
        
        setTimeout(() => {
          closeForm();
        }, 3000);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      alert("התרחשה שגיאה, אנא נסו שוב מאוחר יותר");
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  if (!imagesLoaded) {
    return <LoadingEffect/>;
  }

  return (
    <section ref={heroRef} className={styles.heroWrapper}>
      {/* חלק עליון - 2/3 - גלריית תמונות */}
      <div className={styles.hero}>
        <div className={styles.imageContainer}>
          <img
            ref={imageRef}
            src={projects[currentIndex]?.image}
            alt={projects[currentIndex]?.title}
            className={styles.heroImage}
          />
          <div ref={overlayRef} className={styles.overlay}></div>
        </div>

        <div className={styles.content}>
          <div className={styles.glassContainer}>
            <div className={styles.brandName}>
              TALI ATIA
            </div>
            <div className={styles.subtitle}>
              <p>interior designer</p>
            </div>
            <div className={styles.ctaButtons}>
              <button 
                className={styles.ctaButton}
                onClick={scrollToProjects}
                aria-label="View projects"
              >
                <span className={styles.ctaButtonText}>למבחר הפרוייקטים</span>
                <svg className={styles.ctaButtonIcon} width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              <button 
                className={`${styles.ctaButton} ${styles.ctaButtonPrimary}`}
                onClick={handleContactClick}
                aria-label="Contact us"
              >
                <span className={styles.ctaButtonText}>ליצירת קשר מיידי</span>
                <svg className={styles.ctaButtonIcon} width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div 
          className={styles.navigation}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <button 
            className={`${styles.navButton} ${styles.navPrev}`}
            onClick={handlePrev}
            aria-label="Previous project"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <button 
            className={`${styles.navButton} ${styles.navNext}`}
            onClick={handleNext}
            aria-label="Next project"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <div className={styles.dotsContainer}>
            {projects.map((_, index) => (
              <button
                key={index}
                className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ''}`}
                onClick={() => handleDotClick(index)}
                aria-label={`Go to project ${index + 1}`}
              >
              </button>
            ))}
          </div>
        </div>

        <div className={styles.scrollIndicator}>
          <div className={styles.scrollLine}></div>
          <span className={styles.scrollText}>גלול למטה</span>
        </div>
      </div>

      {/* חלק תחתון - 1/3 - כיתוב בכתב יד */}
      <div ref={signatureRef} className={styles.signatureSection}>
        <div className={styles.signatureContent}>
          <p className={`${styles.signatureLine1} animate-in`}>
            בית הוא לא רק ארבעה קירות.
          </p>
          <p className={`${styles.signatureLine2} animate-in`}>
            בית מכיל חיים ונשמה ואנשים שזקוקים להתרגש בו בכל יום מחדש
          </p>
       
       
        
        </div>
        <div className={styles.signatureDecoration}>
          <svg className={styles.decorativeLine} viewBox="0 0 200 2" fill="none">
            <path d="M0 1H200" stroke="currentColor" strokeWidth="0.5" strokeDasharray="4 4"/>
          </svg>
        </div>
      </div>

      {/* Form Overlay */}
      {isFormOpen && (
        <div className={styles.contactOverlay + ' ' + styles.active} onClick={closeForm}>
          <div className={styles.contactForm} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeButton} onClick={closeForm}>
              <FaTimes />
            </button>
            
            <h2 className={styles.formTitle}>יצירת קשר</h2>
            
            <form onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>שם מלא</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  className={`${styles.formInput} ${errors.fullName ? styles.inputError : ''}`}
                  placeholder="השם שלכם"
                  disabled={isSubmitting || submitted}
                />
                {errors.fullName && <p className={styles.errorText}>{errors.fullName}</p>}
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>מספר טלפון</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className={`${styles.formInput} ${errors.phone ? styles.inputError : ''}`}
                  placeholder="050-1234567"
                  disabled={isSubmitting || submitted}
                />
                {errors.phone && <p className={styles.errorText}>{errors.phone}</p>}
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>סיבת פנייה</label>
                <select
                  name="reason"
                  value={formData.reason}
                  onChange={handleInputChange}
                  className={`${styles.formSelect} ${errors.reason ? styles.inputError : ''}`}
                  disabled={isSubmitting || submitted}
                >
                  <option value="">בחרו סיבת פנייה</option>
                  <option value="שיפוץ">שיפוץ</option>
                  <option value="קניתי דירה מקבלן">קניתי דירה מקבלן</option>
                  <option value="אחר">אחר</option>
                </select>
                {errors.reason && <p className={styles.errorText}>{errors.reason}</p>}
              </div>
              
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                marginTop: "20px",
                marginBottom: "20px"
              }}>
                <label style={{ 
                  direction: "rtl", 
                  fontFamily: "AssistantR", 
                  fontSize: "0.9rem", 
                  textAlign: "right", 
                  display: "flex", 
                  color:"rgb(125, 110, 103)",
                  alignItems: "center", 
                  flexWrap: "wrap", 
                  gap: "5px" 
                }}>
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={() => setAgreed(!agreed)}
                    style={{ marginLeft: "10px" }}
                    disabled={isSubmitting || submitted}
                  />
                  קראתי את
                  <span onClick={handlePrivacyClick}>
                    <PrivacyPolicy 
                      ownerName="טלי אטיה" 
                      email="tali.atia.interior@gmail.com"
                      phone="+972544493213"
                      domain="https://tali-atia.co.il/"
                    />
                  </span>
                  ואני מאשר/ת
                </label>
              </div>
              
              <div className={styles.formButtons}>
                <button 
                  type="submit" 
                  className={`${styles.submitButton} ${isSubmitting ? styles.submitting : ''} ${submitted ? styles.submitted : ''}`}
                  disabled={isSubmitting || submitted}
                >
                  {isSubmitting ? 'שולח...' : submitted ? 'נשלח בהצלחה!' : 'טלי, בואי נדבר'}
                </button>
                <button 
                  type="button" 
                  className={styles.cancelButton}
                  onClick={closeForm}
                  disabled={isSubmitting || submitted}
                >
                  ביטול
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroSection;